module.exports = __webpack_public_path__ + "img/error-dark.b24e719d.svg";